/**
 * Web Share API (mobile + some desktop) or mailto fallback for emailing a PDF.
 */

export function canSharePdfFile(blob: Blob, filename: string): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
    return false;
  }
  try {
    const file = new File([blob], filename, { type: 'application/pdf' });
    return navigator.canShare?.({ files: [file] }) ?? false;
  } catch {
    return false;
  }
}

/** Returns true if the system share sheet opened successfully. */
export async function sharePdfFile(blob: Blob, filename: string, title: string): Promise<boolean> {
  const file = new File([blob], filename, { type: 'application/pdf' });
  const data: ShareData = { files: [file], title, text: title };
  if (!navigator.canShare?.(data)) return false;
  await navigator.share(data);
  return true;
}

export function openEmailComposerForPdf(subject: string, filename: string): void {
  const body = `Attach the exported PDF: ${filename}\n\n(On desktop, attach the file from your Downloads folder after saving.)`;
  const href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = href;
}
